// extracted by mini-css-extract-plugin
export var border = "_1o-7";
export var brand = "_1o-r";
export var button = "_1o-j";
export var center = "_1o-9";
export var centered = "_1o-5";
export var closeButton = "_1o-b";
export var disabledWrapper = "_1o-k";
export var error = "_1o-n";
export var extraLarge = "_1o-4";
export var extraSmall = "_1o-1";
export var fill = "_1o-g";
export var footer = "_1o-f";
export var footerAction = "_1o-h";
export var footerButtons = "_1o-i";
export var header = "_1o-6";
export var icon = "_1o-m";
export var info = "_1o-q";
export var inline = "_1o-8";
export var large = "_1o-3";
export var main = "_1o-c";
export var modal = "_1o-0";
export var neutral = "_1o-s";
export var noPadding = "_1o-e";
export var none = "_1o-t";
export var scrollable = "_1o-d";
export var small = "_1o-2";
export var success = "_1o-p";
export var tight = "_1o-l";
export var titleIcon = "_1o-a";
export var warn = "_1o-o";